module.exports = __webpack_public_path__ + "img/FF-Business-Colour-Print.25b1e614.png";